export const inBrowser = typeof window === "object";
export const onServer = typeof window === "undefined";
